<template>
  <div class="oversea" :class="{'noPC':!isPC}">
    <div class="VerifyBox" :class="['isPayoneer'+isPayoneer,queryType]">
      <img :src='imagesVerify'>
      <div class="verifyTxet">{{verifyTxet}}</div>
      <p class="wait" v-if="isPayoneer==1||isPayoneer==0">Wait 1-3 working days for the seller audit by Card Hobby.</p>
      <div>
        <el-button v-if="isPayoneer==2||isPayoneer==3" class="verifyButton" @click="isGoBack">{{buttonTxet}}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import bus from '@/api/bus';
import { getInfo,setInfo } from "@/api/public";
export default {
  name: 'index',
  data() {
    return {
      queryType: 'stripe',
      timer: '',
      nowData: 2,
      imagesVerify: "../../../static/images/icon/icon_payonner_loading.svg",
      verifyTxet: 'Inactive...',
      buttonTxet: '',
      isPayoneer: 1,
      isPC: false,
      loading: false,
      userInfo: '',
    }
  },
  mounted() {},
  created() {
    //console.log(this.$route,'this.$router',this.$route.query.type)
    bus.$emit('headerTitle', 'Become a Seller');
    this.pcShow()
    if (!this.isPC) {
      var type = '?type=stripe';
      var id = 'id=' + this.$route.query.id + '&code=' + this.$route.query.code
      if (this.$route.query.type != 'stripe') {
        type = '?' + id
      } else {
        type += '&' + id
      }
      if (this.$route.path == "/terms/merchants") {
        this.$router.push({
          path: '/merchants' + type
        })
      } else {

      }
    }
    if (this.$route.query.type != 'stripe') {
      this.queryType = ''
      clearInterval(this.timer);
      this.cardTimer()
    }
  },
  methods: {
    //倒计时
    cardTimer() {
      let that = this
      this.timer = setInterval(() => {
        this.nowData = this.nowData - 1;
        if (this.nowData <= 0) {
          clearInterval(this.timer);

          this.PayoneerConfig()

        }
      }, 1000);
    },
    pcShow() {
      let that = this
      let ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('windows') > -1 || ua.indexOf('intel mac os') > -1) {
        that.isPC = true
        if (this.$route.path != "/terms/merchants") {

          this.$router.push({
            path: '/terms/merchants'
          })
        }
      }
      this.userInfo = getInfo();
      //this.PayoneerConfig()
    },
    isGoBack() {
      let that = this
      if (that.isPayoneer == 2) {
        if(that.isPC){
          //pc端
          
          setInfo('IsSeller', true)
          window.location.href = process.env.VUE_APP_SELL_URL
        }else{
          //移动端
          let ua = navigator.userAgent.toLowerCase();
         // console.log('ua', ua)
          //android终端
          let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 || ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
         // console.log('isAndroid', isAndroid)
          //ios终端
          let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

          let data = { "status": this.isPay ? 1 : 0, "type": this.isText }
          if (!isAndroid) {
            //ios
           // console.log(" 我是ios")
            //这里是和IOS商量好的写法，调用IOS的finishActivity方法
            try {
              window.webkit.messageHandlers.sellerCallback.postMessage('')
            } catch (error) {
              console.log('WKWebView post message');
            }
          } else if (isAndroid) {
            //android
           // console.log("我是android", JSON.stringify(data));
            //这里是和安卓商量好的写法，调用安卓的finishActivity方法
            //android.PayCallback('我是android测试传值');           
            android.sellerCallback('');
          }
        }
      }
      if(that.isPayoneer==3){
        var url='/becomeseller?id=' + that.$route.query.id + '&code=' + that.$route.query.code
        if(that.isPC){
          url='/terms/becomeseller'
        }
        that.$router.push({
          path: url
        })
      }
    },
    PayoneerConfig() {
      let that = this
      const config = () => {

        let data = { id: (that.userInfo.MappingUserId || that.$route.query.id) }
        that.$get(this.$interface.PayoneerConfig, data).then(res => {
          if (res.Result == 1) {
            that.isPayoneer = res.Data
           // that.isPayoneer = 2
            if (that.isPayoneer == 3) {
              that.verifyTxet = 'Refused by Payoneer!'
              that.imagesVerify = '../../../static/images/icon/icon_payonner_close.svg'
              that.buttonTxet = 'Reapply'
            }
            if (that.isPayoneer == 2) {
              that.verifyTxet = 'Active!'
              that.imagesVerify = '../../../static/images/icon/icon_payonner_finish.svg'
              that.buttonTxet = 'Start Selling'
            }
          }
        })
      }
      if (this.isPC) {
        if (this.userInfo) {
          config()
        } else {
          this.$router.push({
            path: '/login'
          })
        }
      } else {
        config()
      }
    }

  }
}

</script>
<style scoped>
.oversea {
  background-color: rgba(240, 243, 255, 1);
  width: 100%;
  position: relative;
  margin-bottom: -35px;
}

.oversea:before {
  content: "";
  background: url(../../../static/images/activty/becomeseller/bg.jpg) center;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  /*  transform: rotate(-45deg);*/
}

.VerifyBox {
  position: relative;
  z-index: 1;
  font-size: 48px;
  font-weight: 700;
  margin: 180px 0 80px;
  padding-bottom: 100px;
  text-align: center;
  color: #5F6DAE;
  background: url(../../../static/images/icon/Payoneer_Master_Logo.svg) center 95% no-repeat;
}

.VerifyBox.stripe {
  background: none;
}

.wait {
  color: #333;
  font-size: 14px;
  margin: 10px 0;
}

.verifyTxet {
  font-size: 30px;
  margin: 10px 0;
}

.verifyButton {
  color: #fff;
  background-color: #5F6DAE;
  height: 40px;
  min-width: 200px;
}

.VerifyBox img {
  width: 100px;
}

.noPC.oversea {
  margin: 0;
  height: 100vh;
  width: 100vw;
}

.noPC.oversea:before {
  position: fixed;
}

.noPC .VerifyBox {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

</style>



// WEBPACK FOOTER //
// src/pages/terms/merchants.vue